const agentToClassMap = {
    "kayo": "initiator",
    "raze": "duelist",
    "chamber": "sentinel",
    "jett": "duelist",
    "killjoy": "sentinel",
    "viper": "controller",
    "sova": "initiator",
    "breach": "initiator",
    "omen": "controller",
    "astra": "controller",
    "skye": "initiator",
    "sage": "sentinel",
    "brimstone": "controller",
    "cypher": "sentinel",
    "yoru": "duelist",
    "neon": "duelist",
    "fade": "initiator",
    "reyna": "duelist",
    "phoenix": "duelist",
    "harbor": "controller",
    "gekko": "initiator",
}

export default agentToClassMap;